export enum DeviationIndicator {
  Down = 'Down',
  Up = 'Up',
  None = 'None'
}
